//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'ToolLayout',
  props: {
    tool: {
      type: Object,
      required: true,
    },
  },
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    BeforeLeaveModal: () => import('@/components/modals/BeforeLeaveModal.vue'),
    BillingButton: () => import('@/components/core/BillingButton.vue'),
  },
  computed: {
    ...mapState({
      member: state => state.user.member,
      isProgress: state => state.leave.isProgress,
      showLeaveMessage: state => state.leave.showLeaveMessage,
    }),
    pageTitle() {
      return _.get(this.tool, 'title');
    },
    pageDescription() {
      return _.get(this.tool, 'desc');
    },
    isSubscriptionPlan() {
      return this.member.studioAiSubscriptionType === 'subscription';
    },
  },
  methods: {
    checkBeforeLeave(event) {
      console.log(event);
      if (this.isProgress && this.showLeaveMessage) {
        event.preventDefault();
        event.returnValue = ''; // This line is necessary for some browsers to display the default confirmation dialog
      }
    },
  },
  created() {
    window.addEventListener('beforeunload', this.checkBeforeLeave);
    this.$router.beforeEach((to, from, next) => {
      if (this.isProgress && this.showLeaveMessage && (from.path !== to.path)) {
        this.$store.dispatch('leave/setLeaveTo', to);
        this.$bvModal.show('before-leave-modal');
        // Prevent route change, user must choose to stay or leave explicitly
      } else {
        next();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.checkBeforeLeave);
  },
};
